import {
    GENERATE_VALIDATION_CODE,
    GENERATE_VALIDATION_CODE_RESULT,
    COMMON_TOGGLE_SIDEBAR,
    COMMON_CHANGE_SELECT_LANGUAGE,
    COMMON_DATAVIEW_GET_DATA_REQUEST,
    COMMON_DATAVIEW_GET_DATA_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

export const toggleSidebar = (open) => ({
    type: COMMON_TOGGLE_SIDEBAR,
    payload: { open }
});

export const clearRedux = (option, parameters, instanceId) => ({
    type: CLEAR_REDUX,
    payload: { option: option || "", parameters, instanceId }
});

export const setChangeSelectLanguage = (lan) => ({
    type: COMMON_CHANGE_SELECT_LANGUAGE,
    payload: lan
});

export const getDataViewRequest = (entity, query, page, rows, sort, conditions) => ({
    type: COMMON_DATAVIEW_GET_DATA_REQUEST,
    payload: { entity, query, page, rows, sort, conditions }
});

export const getDataViewResult = (result, entity) => ({
    type: COMMON_DATAVIEW_GET_DATA_RESULT,
    payload: { ...result, entity }
});

export const generateValidationCode = (action, entityName, entityId) => ({
    type: GENERATE_VALIDATION_CODE,
    payload: { action, entityName, entityId }
});

export const generateValidationCodeResult = (data) => ({
    type: GENERATE_VALIDATION_CODE_RESULT,
    payload: data
});